import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '../../Loader/LinearProgress'
import { addNotification } from 'redux/modules/notifier'
import { useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import CardLink from '../../CardLink/CardLink'
import { TelemetriaIcon } from './icones/Telemetria'
import { useTokenEngecomp } from 'hooks/api/users'

// As credenciais (SSO login do usuário ou login genérico de cliente/gestor)
// são resolvidas no backend — ver EngecompService::SsoLogin.
const useEngecompRedirect = () => {
  const dispatch = useDispatch()
  const { mutate, isLoading } = useTokenEngecomp()

  const redirect = () => {
    // Abre a aba ainda dentro do clique para não ser bloqueada como popup;
    // a URL com o token é definida quando o login terminar.
    const novaAba = window.open('', '_blank')
    if (novaAba) novaAba.opener = null

    mutate(undefined, {
      onSuccess: ({ token }) => {
        const url = `https://solarhub.engecomp.io/?accessToken=${token}`
        if (novaAba) {
          novaAba.location.href = url
        } else {
          window.open(url, '_blank')
        }
      },
      onError: error => {
        if (novaAba) novaAba.close()
        const detalhe = error?.response?.data?.errors || error?.message || ''
        dispatch(
          addNotification({
            key: new Date().getTime().toString(),
            message: `Problema ao fazer login na Telemetria, tente novamente mais tarde. ${detalhe}`,
            options: { variant: 'error' },
          })
        )
      },
    })
  }

  return { redirect, isLoading }
}

export const EngecompLink = () => {
  const classes = useStyles()
  const { redirect, isLoading } = useEngecompRedirect()

  return (
    <Grid item sm={6} md={4} xl={3} className={classes.gridItem}>
      <LinearProgress isLoading={isLoading} />
      <CardLink
        title={'Telemetria'}
        icon={<TelemetriaIcon />}
        action={redirect}>
        Acompanhamento de medições de energia online e simultânea
      </CardLink>
    </Grid>
  )
}

export const MenuLinkEngecomp = {
  icon: <TelemetriaIcon cliente={true} />,
  text: 'Telemetria',
  useAction: () => useEngecompRedirect().redirect,
}

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.defaultPadding,
    margin: 0,
    marginTop: theme.spacing(1.5),
    width: '100%',
  },
  gridItem: {
    width: '100% !important',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
}))
